<script>
	import { onDestroy, getContext } from 'svelte'
	import { admin } from '../library/scripts/PhpHandler.svelte'
	import { downloadUrl } from '../library/scripts/Setup.svelte'
	import { styles } from '../library/scripts/styles'
	import TwoCols from '../library/columLayouts/TwoCols.svelte'
	import { storeShowRoomDetail, storeRoomConfirm, storeData } from '../library/scripts/Store.svelte'
	import GuestHouseCheck from './GuestHouseCheck.svelte'
	import GuestHouseBook from './GuestHouseBook.svelte'
	export let room = ''

	const globals = getContext('globals')
	const fsTitle = globals.fsL
	const fsSize = globals.fsN
	const fsText = globals.fsS
	const fsPrice = globals.fsN
	const fsButton = globals.fsS
	const buttonColor = globals.buttonColor
	const buttonHover = globals.buttonHover
	const isMobi = globals.mobi
	const devWidth = globals.devWidth

	//the folder from which to take images
	let folder

	if (!isMobi) {
		if (devWidth >= 1440) folder = '/large/'
		if (devWidth < 1440 && devWidth >= 800) folder = '/medium/'
		if (devWidth < 800) folder = '/small/'
	}

	// mobile devices
	if (isMobi) {
		if (devWidth < 1440 && devWidth >= 800) folder = '/medium/'
		else folder = '/small/'
	}

	//get the room details from DB
	const roomDetails = admin({
		cmd: 'get_room',
		room: room,
	})

	//get the room details from DB
	let seasons = admin({
		cmd: 'get_seasons',
	})

	//show the confirmation window
	let showConfirmation
	const stoConfirmation = storeRoomConfirm.subscribe((value) => {
		showConfirmation = value
	})

	//get the configFile from store
	let configFile
	const stoData = storeData.subscribe((value) => {
		configFile = value
	})

	const close_window = () => {
		storeShowRoomDetail.set(false)
	}

	let imgPath = downloadUrl + '/rooms/' + folder

	onDestroy(() => {
		stoData
		stoConfirmation
	})
</script>

<div
	style="
    color:white;
    "
>
	{#await roomDetails}
		... content loading
	{:then details}
		{#if !showConfirmation}
			<TwoCols
				column="250px"
				alignVertical="flex-start"
				backgroundColor="transparent"
				width="100vw"
				padding="5%"
				scroll="scroll"
			>
				<div slot="column1" class="column1" use:styles={{ fsTitle }}>
					<div
						style="
					display:flex;
					width:100%;
					justify-content:center;
					margin-bottom: 20px;
					font-size:{fsTitle};
					font-weight:bold;
					font-style:italic;
					text-decoration:underline;
					"
					>
						Room {details.room.number}
					</div>
					<img class="room_image" src="{imgPath}{details.room.image}" alt="room" />

					<div class="sub_title" style="margin-top:20px;" use:styles={{ fsSize }}>high seasons</div>
					{#await seasons then season}
						{#if season.fetch !== 0}
							{#each season.fetch as seasonDetail}
								<div
									style="
										display:grid;
										width:70%;
										grid-template-columns: 1fr 0.2fr 1fr 0.2fr 1fr;
										font-size:{fsText};
										margin-bottom: 10px;
										"
								>
									<div>{seasonDetail[0]}</div>
									<div>:</div>
									<div>{seasonDetail[1]}</div>
									<div>-</div>
									<div>{seasonDetail[2]}</div>
								</div>
							{/each}
						{:else}
							<div style="font-size: {fsText};">no seasons set</div>
						{/if}
					{/await}
				</div>
				<div slot="column2" class="column2">
					<div class="sub_title" use:styles={{ fsSize }}>bed size</div>
					<div
						style="
								font-size:{fsSize};
								margin-bottom:20px;
								"
					>
						{details.room.bedSize}
					</div>

					<div class="sub_title" use:styles={{ fsSize }}>sleeps</div>
					<div
						style="
								font-size:{fsSize};
								margin-bottom:20px;
								"
					>
						{details.room.guests}
					</div>

					<div class="sub_title" use:styles={{ fsSize }}>description</div>
					<div
						style="
								font-size:{fsText};
								margin-bottom: 20px;
								"
					>
						{details.room.description}
					</div>

					<div class="sub_title" use:styles={{ fsSize }}>breakfast</div>
					<div
						style="
								font-size:{fsText};
								margin-bottom: 20px;
								"
					>
						{#if details.room.breakfast === '1'}
							included
						{:else}
							not included
						{/if}
					</div>

					<div class="sub_title space_top" use:styles={{ fsSize }}>low/high season price</div>
					<div
						style="
						font-size:{fsPrice};
						font-weight: bold;
						margin-bottom: 20px;
						"
					>
						{details.room.currency}
						{details.room.low} / {details.room.high}
					</div>
					<GuestHouseCheck {room} />
					<div class="button_container">
						<button use:styles={{ fsButton, buttonColor, buttonHover }} on:click={close_window}>close</button>
					</div>
				</div>
			</TwoCols>
		{:else}
			<GuestHouseBook />
		{/if}
	{/await}
</div>

<style>
	.column1 {
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		align-items: center;
		height: 100%;
		width: 100%;
		border: 1px solid lightgrey;
		padding: 20px;
	}

	.column2 {
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		align-items: flex-start;
		height: 100%;
		width: 100%;
		padding: 20px;
	}

	.space_top {
		margin-top: 20px;
	}

	.sub_title {
		font-size: var(--fsSize);
		font-style: italic;
		font-weight: bold;
		text-decoration: underline;
		margin-bottom: 10px;
	}

	.room_image {
		height: clamp(100px, 20vw, 400px);
		object-fit: cover;
		border: 1px solid greenyellow;
	}

	.button_container {
		display: flex;
		width: 100%;
		justify-content: flex-end;
		margin-top: 20px;
	}

	button {
		display: flex;
		justify-content: center;
		align-items: center;
		background-color: transparent;
		font-size: var(--fsButton);
		color: var(--buttonColor);
		border: 1px solid white;
		border-radius: 10px;
		cursor: pointer;
		width: 100px;
		height: 30px;
	}

	button:hover {
		background-color: var(--buttonHover);
	}
</style>
